<template>

  <section class="work" id="work" ref="workPosition">
    <div class="container">
      <div class="row">
        <div class="col-md-8 offset-md-2 text-center">
          <div class="section-title">
            <h2>How chatloop Work</h2>
            <img
              src="../assets/images/title-line.png"
              alt="white-line"
              class="img-fluid"
            />
            <p>
              Lorem ipsum dolor sit amet, consectetur adipisicing elit. Rem
              autem voluptatem obcaecati! ipsum dolor sit Rem autem voluptatem
              obcaecati
            </p>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-4 text-center">
          <div class="process-box">
            <img src="../assets/images/icon/1.png" alt="" />
            <h3>download app</h3>
            <p>
              Lorem ipsum dolor sit amet, consectetur adipisicing elit.
              Molestias non nulla placeat, odio
            </p>
            <img src="../assets/images/icon/1.png" alt="" class="bg-icon" />
          </div>
        </div>
        <div class="col-lg-4 text-center">
          <div class="process-box">
            <img src="../assets/images/icon/2.png" alt="" />
            <h3>conect people</h3>
            <p>
              Lorem ipsum dolor sit amet, consectetur adipisicing elit.
              Molestias non nulla placeat, odio
            </p>
            <img src="../assets/images/icon/2.png" alt="" class="bg-icon" />
          </div>
        </div>
        <div class="col-lg-4 text-center">
          <div class="process-box">
            <img src="../assets/images/icon/3.png" alt="" />
            <h3>enjoy app</h3>
            <p>
              Lorem ipsum dolor sit amet, consectetur adipisicing elit.
              Molestias non nulla placeat, odio
            </p>
            <img src="../assets/images/icon/3.png" alt="" class="bg-icon" />
          </div>
        </div>
      </div>
    </div>
  </section>

</template>
<script>
export default {
  name: "Work",
  mounted() {
    let payload = {
      position: this.$refs["workPosition"].offsetTop,
      name: "workPosition",
    };
    this.$emit("windowPosition", payload);
  },
};
</script>
